import { Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  IHttpErrorPayload,
  HttpRequestPayload,
  IHttpSuccessPayload,
} from '@core/models';
import { HttpProviderService } from '../../../core/services/http-provider/http-provider.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionTypeService {
  constructor(private httpProvider: HttpProviderService) {}

  fetchTransactionType(): Observable<any> {
    const requestPayload: HttpRequestPayload = {
      resource: '/lov',
      method: 'GET',
      queryParams: [
        {
          key: 'lovId',
          value: 'TRANSACTIONTYPE',
        },
        {
          key: 'lookup',
          value: 1,
        },
      ],
    };
    return this.httpProvider.invokeApi(requestPayload).pipe(
      map((response: IHttpSuccessPayload<any>) => {
        return response.body.Data;
      }),
      catchError((err: IHttpErrorPayload) => throwError(err))
    );
  }
}
